import React from "react";
import "./index.scss";

const Countdown = ({ days, hours, minutes, seconds }) => {
  return (
    <div className="countdown">
      <div className="countdownContent">
        <div className="box">
          <h3>{days}</h3>
          <p>Days</p>
        </div>
        <span>:</span>
        <div className="box">
          <h3>{hours}</h3>
          <p>Hours</p>
        </div>
        <span>:</span>
        <div className="box">
          <h3>{minutes}</h3>
          <p>Minutes</p>
        </div>
        <span>:</span>
        <div className="box">
          <h3>{seconds}</h3>
          <p>Seconds</p>
        </div>
      </div>
    </div>
  );
};

export default Countdown;
